export default __webpack_public_path__ + "static/media/sad-face.a2daae9b.svg";